module.exports = __webpack_public_path__ + "static/img/product_top.5b52c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/product_top.png
// module id = uKIT
// module chunks = 1